import { render, staticRenderFns } from "./EnterpriseLegend.vue?vue&type=template&id=220e5ee8&scoped=true"
import script from "./EnterpriseLegend.vue?vue&type=script&lang=ts"
export * from "./EnterpriseLegend.vue?vue&type=script&lang=ts"
import style0 from "./EnterpriseLegend.vue?vue&type=style&index=0&id=220e5ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e5ee8",
  null
  
)

export default component.exports